import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationState } from '@store/reducers';
import { selectCredential } from '@store/selectors';
import { AUTHENTICATION_RESET, STATE_FIND_ALL } from '@store/actions';

export const authGuard = (): Observable<boolean | UrlTree> => {
  const store = inject(Store<AuthenticationState>);
  const router = inject(Router);

  return store.select(selectCredential).pipe(
    map((credental) => {
      if (!!credental?.granted && credental?.token) {
        store.dispatch(AUTHENTICATION_RESET());
        store.dispatch(STATE_FIND_ALL());
        return true;
      } else {
        router.navigate(['/login']);
        return false;
      }
    }), 
  );
};
